import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { AuthShell } from "@/pages/AuthShell";
import { Loader2 } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { toast.error("Passwords don't match"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated. Please log in.");
      navigate("/login", { replace: true });
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <AuthShell title="Choose a new password" subtitle="At least 6 characters.">
      {!token ? (
        <p className="text-sm text-red-600" data-testid="reset-missing-token">This reset link is missing its token. <Link to="/forgot-password" className="underline">Request a new one</Link>.</p>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <div><Label>New password</Label><Input data-testid="reset-password" type="password" minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-1" /></div>
          <div><Label>Confirm password</Label><Input data-testid="reset-confirm" type="password" minLength={6} value={confirm} onChange={(e) => setConfirm(e.target.value)} required className="mt-1" /></div>
          <Button type="submit" disabled={loading} className="w-full h-11 bg-primary text-white" data-testid="reset-submit">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Update password"}
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
